import AnnulLessonModal from './AnnulLessonModal';

export default AnnulLessonModal;
